var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KITSCombo',{attrs:{"propertyName":"val","propertyID":"id","hasAllOption":_vm.hasAllOption,"firstItemValue":_vm.firstItemValue,"items":_vm.items,"value":_vm.selectedvalue,"firstItemText":this.firstItemText},on:{"input":_vm.inputEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }